var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fr_svg__clip0_1243_4635)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h21v21H0V.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .5h7.001v21H0V.5z",
    fill: "#002654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.998.5h7.001v21h-7.001V.5z",
    fill: "#CE1126"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fr_svg__clip0_1243_4635"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#fff"
  })))));
}
export default SvgFr;